var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/public_layout/components/footer.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { List as ImmutableList } from 'immutable';
import React from 'react';
import { Link } from 'react-router-dom';
import { getSettings } from 'soapbox/actions/settings';
import { getSoapboxConfig } from 'soapbox/actions/soapbox';
import { Text } from 'soapbox/components/ui';
import { useAppSelector } from 'soapbox/hooks';
const Footer = () => {
  const {
    copyright,
    navlinks,
    locale
  } = useAppSelector(state => {
    const soapboxConfig = getSoapboxConfig(state);
    return {
      copyright: soapboxConfig.copyright,
      navlinks: soapboxConfig.navlinks.get('homeFooter') || ImmutableList(),
      locale: getSettings(state).get('locale')
    };
  });
  return /*#__PURE__*/React.createElement("footer", {
    className: "relative max-w-7xl mt-auto mx-auto py-12 px-4 sm:px-6 xl:flex xl:items-center xl:justify-between lg:px-8",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 7
    }
  }, navlinks.map((link, idx) => {
    const url = link.get('url');
    const isExternal = url.startsWith('http');
    const Comp = isExternal ? 'a' : Link;
    const compProps = isExternal ? {
      href: url,
      target: '_blank'
    } : {
      to: url
    };
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "px-5 py-2",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Comp, _extends({}, compProps, {
      className: "hover:underline",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Text, {
      tag: "span",
      theme: "primary",
      size: "sm",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 17
      }
    }, link.getIn(['titleLocales', locale]) || link.get('title'))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-6 xl:mt-0",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    align: "center",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 9
    }
  }, copyright)));
};
export default Footer;